export const OBSERVATIONS_MODEL_KEYS = {
  COMMENTS_LIST: "observations.comments" as const,
};
